import { render, staticRenderFns } from "./InspectOrder.vue?vue&type=template&id=8f674ae2&scoped=true"
import script from "./InspectOrder.vue?vue&type=script&lang=js"
export * from "./InspectOrder.vue?vue&type=script&lang=js"
import style0 from "./InspectOrder.vue?vue&type=style&index=0&id=8f674ae2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f674ae2",
  null
  
)

export default component.exports